import { useEffect } from 'react';
import useCustomHook from '@/hooks/useCustomHook';
import ActivityTypes from '@/constants/ActivityTypes';

export default function useThemeActivitiesLinks({
  themeActivities,
  omitActivityIds,
}) {
  const { state, actions } = useCustomHook({
    defaultState: {
      activityGroups: [],
    },
    actions: {},
  });

  useEffect(() => {
    if (themeActivities) {
      const filteredActivities = themeActivities.filter(
        (activity) => !omitActivityIds.includes(activity.id)
      );
      const sortedGroupedActivities = ActivityTypes.typesOrdered.reduce(
        (acc, type) => {
          if (filteredActivities.some((activity) => activity.type === type)) {
            let activitiesGroup = {
              type,
              activities: filteredActivities.filter(
                (activity) => activity.type === type
              ),
            };
            acc.push(activitiesGroup);
          }
          return acc;
        },
        []
      );

      actions.setState({
        activityGroups: sortedGroupedActivities,
      });
    }
  }, [themeActivities]);

  return { state, actions };
}
